import { connect } from "react-redux"
import PropTypes from "prop-types"
import styled from "styled-components"
import { getPageData } from "../../lib/cmsPages"

import { useLocation, useNavigate } from "react-router-dom"
import { BlocksRenderer } from "@strapi/blocks-react-renderer"

import WrapContainer from "../WrapContainer"

import { BackLink } from "../../components/nav/Links"

import { setMetaData } from "../../../utils/metaData"

const ParentDiv = styled.div`
  max-width: 980px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 80px;
  position: relative;

  div > h1 + div {
    text-align: center;
  }
`

function Legals({ isMobile, metaDescription, metaTitle }) {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const content = getPageData(
    pathname === "/privacy" ? "privacy_policy" : "customer_terms",
  )

  if (!content) {
    navigate("/404-page-not-found")
  }

  setMetaData({
    metaTitle: metaTitle || content?.title,
    metaDescription,
  })

  return (
    <WrapContainer loginRequired={false}>
      <ParentDiv>
        <BackLink
          to="/"
          onClick={(e) => {
            e.preventDefault()
            navigate(-1)
          }}
          style={{ left: isMobile ? 20 : -60, top: 20 }}
        />
        <div style={{ paddingTop: isMobile ? 60 : 20 }}>
          <div style={{ padding: isMobile ? "0 8px" : 0, textAlign: "left" }}>
            <BlocksRenderer content={content.content} />
          </div>
        </div>
      </ParentDiv>
    </WrapContainer>
  )
}

Legals.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  metaTitle: PropTypes.string,
  metaDescription: PropTypes.string,
}

function mapStateToProps(state) {
  return {
    isMobile: state.browser.lessThan.mobile,
  }
}

export default connect(mapStateToProps)(Legals)
